import { graphql } from "../gql";

export const getHeadToHeadTopLevelDataQuery = graphql(`
  query GetHeadToHeadTopLevelData($input: OddsMarketTypesInput!) {
    event(input: $input) {
      eventUrl
      numberfireId
      season
      week
      venueName
      venueType
      startTime
      broadcastInfo {
        network
      }
      status
      homeTeam {
        name
        shortName
        abbreviation
        conference
        division
        primaryColor
        secondaryColor
        logoSVG
        numberfireId
        teamJerseySVG
        teamSportsbookUrl
      }
      awayTeam {
        name
        shortName
        abbreviation
        conference
        division
        primaryColor
        secondaryColor
        logoSVG
        numberfireId
        teamJerseySVG
        teamSportsbookUrl
      }
      scoreboard {
        firstQuarter {
          home
          away
        }
        secondQuarter {
          home
          away
        }
        thirdQuarter {
          home
          away
        }
        fourthQuarter {
          home
          away
        }
        overtime {
          home
          away
        }
        finalScore {
          home
          away
        }
        timeoutsRemaining {
          home
          away
        }
        timeoutsTotal
        clock
        possession
        isRedZone
      }
    }
  }
`);
